import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLine'
})

// Return first line from paragraph

export class FirstLinePipe implements PipeTransform {

    transform(value: string, args?: any): any {

        if (value) {

            var splitLine = value.split('.');
            return splitLine.length > 1 ?
                splitLine[0] + '. ' + (splitLine.length > 2 ? splitLine[1] : '') : value

        }

        return value;
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/firstLine.pipe.ts